<template>
  <div class="main">
    <div class="swiper-slide-container" :class="{ mobile: isMobile }" @click="handleClick">
      <img :src="image" alt="slide-image" class="slide-image" />
      <p class="slide-title">{{ title }}</p>
      <p class="slide-description">{{ description }}</p>
      <div v-if="isMobile" class="view-more-container">
        <span class="view-more">查看更多</span>
        <img :src="require('../../assets/images/homeV2/moreV2.png')" alt="icon" class="view-more-icon" />
      </div>
    </div>
  </div>

</template>

<script>
import { browser } from '@/utils/common'
export default {
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isMobile () {
      // return window.innerWidth <= 768
      return browser.isMobile
    }
  },

  methods: {
    handleClick () {
      this.$emit('slideZRClick', this.id) // 发出事件通知父组件
    }
  }

}
</script>

<style scoped lang="less">
.swiper-slide-container {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.slide-image {
  width: 100%;
  border-radius: 24px;
  object-fit: cover;
  aspect-ratio: 475 / 332;
}

.slide-title {
  margin-top: 28px;
  margin-bottom: 8px;
  // font-size: 20px;
  // font-family: "PingFang SC-Medium";
  // color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #262626;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;

}

.slide-description {
  margin-top: 0px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  line-height: 32px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 移动设备适配 */
.mobile {
  .swiper-slide-container {

    border-radius: 12px;
    margin-bottom: 3px;
  }

  .main {
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    margin: 16px;
  }
}

.mobile .slide-image {
  aspect-ratio: 264 / 184;
  border-radius: 12px 12px 0 0;
}

.mobile .slide-title {
  margin-top: 16px;
  margin-left: 16px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  // font-size: 14px;
  color: #262626;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.mobile .slide-description {
  margin-top: 0px;
  margin-left: 16px;
  margin-right: 16px;
  font-size: 12px;
  // min-height: 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  // font-size: 12px;
  color: #595959;
  line-height: 20px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
}

.view-more-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 16px;
}

.view-more {
  font-size: 12px;
  color: #595959;
}

.view-more-icon {
  margin-left: 2px;
  width: 12px;
  height: 12px;
}
</style>
